export interface PanelState {
    user: object;
}

const state = (): PanelState => ({
    user: {},
});

export default state;
